
import styled from 'styled-components';

export const Component = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8); /* Use a semi-transparent background color */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* Ensure it appears on top of other elements */
`;

export const LoaderContainer = styled.div`
position: absolute;
  width: 50px;
   height: 50px;
`;

export const LoaderSpinner = styled.div`
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`
;

